module.exports = __webpack_public_path__ + "img/gaming-pad-01.2ef3e261.svg";